import { Client } from '@/common/services/Client';

export async function startPolicy(uuid: string): Promise<void> {
  const response = await Client.post<void, undefined>({
    endpoint: `/policies/${uuid}/start`,
  });

  return response.data;
}
